<template>
  <div class="cpm-wrapper">
    <div class="cpm-body">
      <el-dialog title="查看对公转账凭证" :visible.sync="dialogVisible" width="620px" :close-on-click-modal="false">
        <div class="dialog-content">
          <ul v-if="auditList.length" class="list">
            <li class="item" v-for="(item, index) in auditList" :key="index">
              <p class="store-name">{{ item.operatorName }} {{ item.operateTime }}</p>
              <p class="store-reply">
                <span v-if="item.status === '审核凭证失败'" class="status">
                  审核不通过。商家备注:{{ item.auditRemark || '无' }}
                </span>
                <span v-else class="status">{{ item.status }}</span>
                <span
                  v-if="item.urls[0] && !(item.status.includes('审核凭证成功') || item.status.includes('审核凭证失败'))"
                  @click="showPic(item.urls[0])"
                  class="showPic pointer"
                >
                  查看凭证
                </span>
              </p>
            </li>
          </ul>
          <span class="text-info" v-else>该订单未上传打款凭证，不支持查看</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button style="border-radius:0" type="primary" @click="onSubmit">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
export default {
  props: {
    orderSn: {
      type: String
    }
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          this.getPayList();
        }
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      auditList: []
    };
  },
  methods: {
    async getPayList() {
      const res = await api.order.listCertificateInfo({ orderSn: this.orderSn });
      this.auditList = res || [];
    },
    showPic(url) {
      this.$previewImg({
        url: url
      });
    },
    async onSubmit() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.cpm-wrapper {
  .cpm-body {
    .dialog-content {
      font-size: 12px;

      .list {
        .item {
          width: 480px;
          // height: 56px;
          padding: 12px 16px;
          background: #f9f9f9;
          margin-bottom: 12px;
          .store-name {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
          }
          .store-reply {
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 18px;
            margin-top: 2px;
          }
          .showPic {
            margin-left: 16px;
            height: 12px;
            font-size: 12px;
            font-weight: 400;
            color: #1e8dff;
            line-height: 12px;
          }
        }
      }
    }
    .text-info {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #595959;
      line-height: 22px;
    }
    .dialog-footer {
      text-align: right;
    }
  }
}
</style>
